module.exports = __webpack_public_path__ + "buyMoreInteral.png?343b014880f237c29977d645fc53150d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buyMoreInteral.png
// module id = 17
// module chunks = 0